import ChatMessage from "../components/my-messages/index";

export default {
  name: "message list",
  component: ChatMessage,
  url: "/my-messages",
  exact: true,
  requireAuth: false
};
